import { motion } from "framer-motion";

export const MaskText = ({ children, delay = 0, className = "" }) => {
  return (
    <span className="line-mask">
      <motion.span
        className={`block ${className}`}
        initial={{ y: "110%" }}
        animate={{ y: "0%" }}
        transition={{ duration: 1.05, ease: [0.19, 1, 0.22, 1], delay }}
      >
        {children}
      </motion.span>
    </span>
  );
};
